// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"bg_bv","reviews__wrapper__list":"bg_fp","reviewSlider":"bg_fq"};